import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

const FractalBinaryTree = () => {
  const rootRef = useRef();

  useEffect(() => {
    const svg = d3.select('.fractal-binary-tree-root svg')

    const length = 200;
    const reduceRate = 0.6;
    const radius = -Math.PI / 2;
    const count = 7;

    const show = (x0, y0, length, reduceRate, radius, count) => {
      const x1 = x0 + length * Math.cos(radius);
      const y1 = y0 + length * Math.sin(radius);
      svg.append('line')
        .attr('x1', x0)
        .attr('y1', y0)
        .attr('x2', x1)
        .attr('y2', y1)
        .attr('style', 'stroke: rgb(99, 99, 99); stroke-width: 2')

      const radiusLeft = radius - Math.PI / 4;
      const radiusRight = radius + Math.PI / 4;

      if(count > 0) {
        show(x1, y1, length * reduceRate, reduceRate, radiusLeft, count - 1);
        show(x1, y1, length * reduceRate, reduceRate, radiusRight, count - 1);
      }
    }

    show(rootRef.current.offsetWidth / 2, 500, length, reduceRate, radius, count);
  }, []);

  return (
    <>
      <h1 className="text-center">分形二叉树</h1>
      <div className="fractal-binary-tree-root" style={{height: 500}} ref={rootRef} >
        <svg
          width="100%"
          height="100%"
        />
      </div>
    </>
  )
}

export default FractalBinaryTree;
